import { Controller } from 'stimulus';
import { prettyPrice, updateQuantity } from '@/helpers/ecommerce/cartHelpers';
import debounce from '@/helpers/debounce';

function getCartPage() {
  return $.ajax({
    url: '/winkelwagen',
  });
}

function parseCartPage(res) {
  return $(res);
}

function getTextFromPage($elements, selector) {
  const $items = $elements.find(selector);

  if (!$items.length) {
    return null;
  }

  return $items.get(0).innerHTML.trim();
}

function extractFromCartPage($elements) {
  return {
    subTotal: getTextFromPage($elements, '[data-target="cart.subTotal"]'),
    totalTax: getTextFromPage($elements, '[data-target="cart.totalTax"]'),
    shippingCosts: getTextFromPage($elements, '[data-target="cart.shippingCosts"]'),
    couponValue: getTextFromPage($elements, '[data-target="cart.couponValue"]'),
    total: getTextFromPage($elements, '[data-target="cart.total"]'),
  };
}

class Cart extends Controller {
  static updatePriceForItem(cartItem) {
    const quantityInput = cartItem.querySelector('[data-target*="cart.quantityInput"]');
    const priceOutput = cartItem.querySelector('[data-target="cart.cartItemPriceOutput"]');

    const quantity = parseInt(quantityInput.value, 10);
    const price = parseFloat(cartItem.getAttribute('data-price'));

    if (Number.isNaN(quantity) || Number.isNaN(price) || !priceOutput) {
      return 0;
    }

    priceOutput.innerHTML = prettyPrice(price * quantity);

    return price * quantity;
  }

  static removeItem(item) {
    item.parentNode.removeChild(item);
  }

  connect() {
    this.updatePricesDebounced = debounce(this.updatePrices.bind(this), 20);
    this.changeQuantityDebounced = debounce(this.changeQuantity.bind(this), 20);
  }

  onQuantityChange({ target }) {
    this.changeQuantityDebounced(target);
  }

  changeQuantity(target) {
    const item = target.closest('[data-target="cart.cartItem"]');
    const quantity = target.value;
    const itemId = item.getAttribute('data-id');
    const price = parseFloat(item.getAttribute('data-price'));

    const priceOutput = item.querySelector('[data-target="cart.cartItemPriceOutput"]');

    if (priceOutput && !Number.isNaN(price) && !Number.isNaN(quantity)) {
      priceOutput.innerHTML = prettyPrice(price * quantity);
    }

    if (parseInt(quantity, 10) === 0) {
      Cart.removeItem(item);
    }

    requestAnimationFrame(() => {
      updateQuantity(itemId, quantity)
        .then(() => {
          this.updatePricesDebounced();
        })
        .catch(() => {
          this.updatePricesDebounced();
        });
    });
  }

  outputToCartPage(cartSpecifications) {
    if (this.hasSubTotalTarget) {
      this.subTotalTarget.innerHTML = cartSpecifications.subTotal;
    }

    if (this.hasTotalTaxTarget) {
      this.totalTaxTarget.innerHTML = cartSpecifications.totalTax;
    }

    if (this.hasShippingCostsTarget) {
      this.shippingCostsTarget.innerHTML = cartSpecifications.shippingCosts;
    }

    if (this.hasCouponValueTarget) {
      this.couponValueTarget.innerHTML = cartSpecifications.couponValue;
    }

    this.totalTarget.innerHTML = cartSpecifications.total;
  }

  updatePrices() {
    getCartPage()
      .then(parseCartPage)
      .then(extractFromCartPage)
      .then(this.outputToCartPage.bind(this));
  }
}

Cart.targets = [
  'quantityInput',
  'cartItem',
  'subTotal',
  'total',
  'totalTax',
  'shippingCosts',
  'couponValue',
];

export default Cart;
